import { ContentMap } from '../../types';
import { angkorWatContent } from './angkor-wat';
import { banteayKdeiContent } from './banteay-kdei';
import { battambangContent } from './battambang';
import { bayonTempleContent } from './bayon-temple';
import { kampongPlukContent } from './kampong-pluk';
import { kampotContent } from './kampot';
import { kepContent } from './kep';
import { kohRongContent } from './koh-rong';
import { kohRongSanloemContent } from './koh-rong-sanloem';
import { phnomPenhContent } from './phnom-penh';
import { relatedArticlesSlugsMap } from './relatedArticlesSlugsMap';
import { siemReapContent } from './siem-reap';
import { sihanoukvilleContent } from './sihanoukville';
import { taKeoContent } from './ta-keo';
import { taProhmContent } from './ta-prohm';
import { tonleSapContent } from './tonle-sap';

export const cambodiaDestinationsContentMap: ContentMap = {
  'siem-reap': siemReapContent,
  sihanoukville: sihanoukvilleContent,
  'koh-rong': kohRongContent,
  'koh-rong-sanloem': kohRongSanloemContent,
  'angkor-wat': angkorWatContent,
  kampot: kampotContent,
  kep: kepContent,
  battambang: battambangContent,
  'kampong-pluk': kampongPlukContent,
  'phnom-penh': phnomPenhContent,
  'tonle-sap': tonleSapContent,
  'ta-prohm': taProhmContent,
  'banteay-kdei': banteayKdeiContent,
  'ta-keo': taKeoContent,
  'bayon-temple': bayonTempleContent,
};

export const cambodiaDestinationsCardData = [
  {
    title: 'סיאם ריפ',
    description:
      'שער לאנגקור ועיר תוססת שמציעה שילוב מושלם של תרבות, טבע, חיי לילה וקולינריה מקומית ובינלאומית',
    imageUrl: 'https://tinyurl.com/siem-reap-preview',
    slug: 'siem-reap',
    date: '03.11.2024',
    readTime: '4',
  },
  {
    title: 'קו רונג',
    description:
      'אי טרופי עוצר נשימה עם חופים בתוליים, מים טורקיז, חיי לילה סוערים ופעילויות טבע וים לכל סגנון של מטייל',
    imageUrl: 'https://tinyurl.com/koh-rong-preview',
    slug: 'koh-rong',
    date: '09.11.2024',
    readTime: '3.5',
  },
  {
    title: 'קו רונג סנלואם',
    description:
      'אי של שלווה וטבע עם חופים חלומיים, אווירה רומנטית ותחושת ניתוק מושלמת מהעולם',
    imageUrl: 'https://tinyurl.com/koh-rong-sanloem-preview',
    slug: 'koh-rong-sanloem',
    date: '15.11.2024',
    readTime: '3',
  },
  {
    title: 'סיהנוקוויל',
    description:
      'עיר חוף משתנה שמציעה חופים זהובים, חיי לילה תוססים, גישה נוחה לאיים קסומים ושילוב ייחודי של אותנטיות ופיתוח מואץ',
    imageUrl: 'https://tinyurl.com/sihanoukville-preview',
    slug: 'sihanoukville',
    date: '23.11.2024',
    readTime: '3',
  },

  {
    title: 'קמפוט',
    description:
      'עיר רגועה וממכרת בלב הטבע, עם נהר שקט, מבנים קולוניאליים, חוויות אותנטיות ואווירה של ניתוק אמיתי מהעולם',
    imageUrl: 'https://tinyurl.com/kampot-preview',
    slug: 'kampot',
    date: '08.12.2024',
    readTime: '3',
  },
  {
    title: 'קפ',
    description:
      'עיירת חוף קסומה ושלווה עם נופים טרופיים, אוכל ים טרי, היסטוריה מרתקת ואווירה מושלמת להתנתקות ורוגע',
    imageUrl: 'https://tinyurl.com/kep-preview',
    slug: 'kep',
    date: '16.12.2024',
    readTime: '2.5',
  },
  {
    title: 'בטאמבאנג',
    description:
      'עיר תרבותית ואותנטית המשלבת היסטוריה מרתקת, אומנות חיה, שווקים תוססים, אוכל מסורתי ונופים כפריים עוצרי נשימה',
    imageUrl:
      'https://github.com/idoyef/lelo-gvulot-images/blob/master/images/cambodia/battambang/battambang-preview.png?raw=true',
    slug: 'battambang',
    date: '24.12.2024',
    readTime: '3',
  },
  {
    title: 'קמפונג פלוק',
    description:
      'כפר מרהיב על כלונסאות בלב הטבע, שמציע הצצה נדירה לאורח חיים מסורתי, שייט קסום ונופי שקיעה עוצרי נשימה על אגם טונלה סאפ',
    imageUrl: 'https://tinyurl.com/kampong-pluk-preview',
    slug: 'kampong-pluk',
    date: '02.01.2025',
    readTime: '2.5',
  },
  {
    title: 'פנום פן',
    description:
      'עיר תוססת המשלבת היסטוריה כואבת, תרבות עשירה, שווקים צבעוניים וקצב אורבני מודרני על רקע שלושת הנהרות הגדולים של קמבודיה',
    imageUrl: 'https://tinyurl.com/phnom-penh-preview',
    slug: 'phnom-penh',
    date: '11.01.2025',
    readTime: '4',
  },
  {
    title: 'אגם טונלה סאפ',
    description:
      'תופעת טבע מרהיבה בלב קמבודיה, עם כפרים צפים, חיים משתנים לפי עונות השנה ומערכת אקולוגית עשירה וייחודית שאין דומה לה באזור',
    imageUrl: 'https://tinyurl.com/tonle-sap-preview',
    slug: 'tonle-sap',
    date: '20.01.2025',
    readTime: '3',
  },
  {
    title: 'מקדש אנגקור וואט',
    description:
      'פלא ארכיטקטוני עוצר נשימה בלב קמבודיה, המשלב היסטוריה, מיתולוגיה ויופי עיצובי במקדש הדתי הגדול בעולם',
    imageUrl: 'https://tinyurl.com/angkor-wat-preview',
    slug: 'angkor-wat',
    date: '01.12.2024',
    readTime: '4',
  },
  {
    title: 'מקדש טה פרום',
    description:
      "מקדש מהפנט בלב הג'ונגל שבו שורשי עצים עצומים חובקים את אבני האבן העתיקות, ויוצרים שילוב מרהיב של טבע, היסטוריה ומסתורין",
    imageUrl: 'https://tinyurl.com/ta-prohm-preview',
    slug: 'ta-prohm',
    date: '29.01.2025',
    readTime: '3.5',
  },
  {
    title: 'מקדש בנטיי קדי',
    description:
      "מקדש שקט ומרשים בלב הג'ונגל של אנגקור, עם תבליטים מרהיבים, פרצופי אבן ועצים שצמחו בין חורבות האבן",
    imageUrl: 'https://tinyurl.com/banteay-kdei-preview',
    slug: 'banteay-kdei',
    date: '09.02.2025',
    readTime: '3',
  },
  {
    title: 'מקדש טא קאו',
    description:
      'פירמידה מסתורית בלב אנגקור, מקדש הינדי לא גמור עם נוף מרהיב ואווירה עוצמתית מהעבר',
    imageUrl: 'https://tinyurl.com/ta-keo-preview',
    slug: 'ta-keo',
    date: '17.02.2025',
    readTime: '2.5',
  },
  {
    title: 'מקדש באיון',
    description:
      'מקדש מסתורי בקמבודיה עם פני אבן מחייכות, תבליטים מרהיבים וסיפור היסטורי מרתק בלב אנגקור',
    imageUrl: 'https://tinyurl.com/bayon-preview',
    date: '15.03.2024',
    readTime: '10',
    slug: 'bayon-temple',
  },
].map((article) => ({
  ...article,
  articleLink: `/international/cambodia/destination/${article.slug}`,
  relatedArticlesSlugs:
    relatedArticlesSlugsMap[
      article.slug as keyof typeof relatedArticlesSlugsMap
    ],
}));
